import React from 'react'
import BoolInput from 'bstrap-react-mobx-admin/new_src/input/bool'
import DateInput from '../../input/date'
import TextInput from 'bstrap-react-mobx-admin/input/text'

const BasicCItemsForm = ({ store, updateField, onHeaderCheckedChange, record, errors }) => {
  return (
    <div>
      <BoolInput label={store.__('Platform specific license period')}
        attr={'platform_specific_licence_period_flg'}
        onHeaderCheckedChange={onHeaderCheckedChange}
        record={record} onChange={updateField} />
      <div className='row'>
        <div className='col-sm-12 col-md-6'>
          <TextInput label={store.__('attribute 1')} attr={'attribute_1'}
            onHeaderCheckedChange={onHeaderCheckedChange}
            record={record} onChange={updateField} errors={errors} />
        </div>
        <div className='col-sm-12 col-md-6'>
          <TextInput label={store.__('attribute 2')} attr={'attribute_2'}
            onHeaderCheckedChange={onHeaderCheckedChange}
            record={record} onChange={updateField} errors={errors} />
        </div>
      </div>
      <TextInput label={store.__('note')} attr={'note'}
        onHeaderCheckedChange={onHeaderCheckedChange}
        record={record} onChange={updateField} errors={errors} />
      <div className='row'>
        <div className='col-xs-6'>
          <DateInput label={store.__('delivered date')} attr={'delivered_date'}
            record={record} onChange={updateField} errors={errors} disabled={false}
            onHeaderCheckedChange={onHeaderCheckedChange} />
        </div>
      </div>
    </div>
  )
}
export default BasicCItemsForm
